<template>
  <validation-provider name="baseInputEditValidationProvider" ref="validationInput" :rules="rules" v-slot="{errors, valid}">
    <div class="input-box">
      <label class="label-text">{{ label }}</label>
      <div class="form-group">
        <input class="form-control" v-model="displayModel" type="checkbox" placeholder="">
        <small v-if="errors.length > 0 ? 'error' : ''" class="error-text">{{errors[0]}}</small>
      </div>
    </div>

<!--    <div class="input-box" >-->
<!--        <div class="form-group form-control">-->
<!--&lt;!&ndash;          <upload-image name="imageValidation" v-model="displayModel"></upload-image>&ndash;&gt;-->
<!--          <small class="error-text">{{errors[0]}}</small>-->
<!--        </div>-->
<!--    </div>-->
  </validation-provider>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";
import UploadImage from "../common/UploadImage";


export default {
  name: "BaseCheckboxInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider, UploadImage},
  data :() => {
    return {
      valid : null,
      displayModel : null
    };
  },
  props : {
    label : null,
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {
    extend("required", {...required,
      message : required.message =  'Required'});
    if(this.inputModel == null){
      this.$emit("change",true);
    }
    this.displayModel = this.inputModel;
  }
}
</script>

<style scoped>

</style>